import { Route } from '@angular/router';
import { SdsComponent } from './sds.component';
import { SdsListComponent } from './components/sds-list.component';
import { SdsNewComponent } from './components/sds-new.component';
import { SdsDetailComponent } from './components/sds-detail.component';
import { SdsExposureRegisterComponent } from './components/sds-exposure-register.component';
import { SdsSubstitutionAssessmentComponent } from './components/sds-substitution-assessment.component';

export const sdsRoutes: Route[] = [
  {
    path: 'safety-data-sheets',
    component: SdsComponent,
    children: [
      {
        path: 'list',
        component: SdsListComponent
      },
      {
        // Reuses the list component in read-only "archived" mode (replaced + deleted).
        path: 'archived',
        component: SdsListComponent,
        data: { archived: true }
      },
      {
        path: 'new',
        component: SdsNewComponent
      },
      {
        path: 'detail/:id',
        component: SdsDetailComponent
      },
      {
        path: 'substitution-assessment',
        component: SdsSubstitutionAssessmentComponent
      },
      {
        path: 'exposure-register',
        component: SdsExposureRegisterComponent
      },
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      }
    ]
  }
];
